import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { renderSimpleMarkdown } from "../../../utils/markdown";

const PurchaseTerms = ({ data, productData, customStyle }) => {
  const { t } = useTranslation();
  const linkColor = customStyle?.link?.linkColor;
  const hoverLinkColor = customStyle?.link?.hoverLinkColor;

  // Theme is applied to every <a> rendered from the markdown, keeping producer link colors.
  const StyledTerms = styled.div`
    a {
      display: inline-block;
      cursor: pointer;
      text-decoration: underline;
      color: ${linkColor};

      &:hover {
        color: ${hoverLinkColor};
        text-decoration: none;
      }
    }
  `;

  const isUrl = (str) => {
    if (str === null || str === undefined || str === "") return false;

    const pattern = new RegExp("^(http|HTTP)+(s|S)?://[\\w.$()/]+(?:\\.[\\w.$()/]+)*[\\w$()/]+$", "g");
    return !!pattern.test(str);
  };

  // The two management-dependent paragraphs are injected into the body via {{managementBlock}}.
  const managementBlock =
    productData?.management === "external"
      ? t("purchaseTerms.managementExternal", { producerEmail: data?.producer?.email })
      : t("purchaseTerms.managementInternal");

  let markdown = t("purchaseTerms.body", {
    producerName: data?.producer?.name,
    producerEmail: data?.producer?.email,
    managementBlock,
  });

  // Optional producer terms line, only when active and the URL is valid.
  if (data?.producer_terms?.active && isUrl(data?.producer_terms?.url)) {
    markdown += "\n\n" + t("purchaseTerms.producerTermsLink", { url: data?.producer_terms?.url });
  }

  const html = renderSimpleMarkdown(markdown);

  return <StyledTerms className="purchase-terms-container" dangerouslySetInnerHTML={{ __html: html }} />;
};

export default PurchaseTerms;
